// Page-local feedback; a dismissed banner must not turn a failed fetch into an empty success.
export function getJobsFeedback(loading: boolean, failed: boolean, count: number, filtered: boolean): string {
  if (loading) {
    return count > 0 ? 'Refreshing jobs… Previously loaded entries remain visible.' : 'Loading jobs…';
  }
  if (failed) {
    return count > 0
      ? 'Jobs could not be refreshed. Previously loaded entries remain visible. Use Refresh to try again.'
      : 'Jobs could not be loaded. Use Refresh to try again.';
  }
  if (count === 0) {
    return filtered ? 'No jobs for this app. Choose All apps to broaden the results.' : 'No jobs yet.';
  }
  return `${count} ${count === 1 ? 'entry' : 'entries'} loaded.`;
}
